const PasswordPageTitles = {
  RESET: "Reset your password",
  UNLOCK: "Unlock your account",
  UPDATE: "Your password has expired: update it before continuing"
}

export default PasswordPageTitles